import { CheckActions, PlusActions } from 'actions'
import Helmet from 'react-helmet'
import { Link } from 'react-router'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Subheader from 'material-ui/Subheader'
import { List, ListItem } from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import FontIcon from 'material-ui/FontIcon'
import { Nav, Button, HelpEmail, Notice, InstallButton } from 'components'
import SearchConsoleContainer from '../../containers/SearchConsoleContainer'
import { Analytics, ResponsiveDialog } from 'common-frontend'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import DoneIcon from 'material-ui/svg-icons/action/done'
import WarningIcon from 'material-ui/svg-icons/alert/warning'
import DangerIcon from 'material-ui/svg-icons/content/clear'
import { SUPPORT_EMAIL } from 'consts'
import InstalledDialog from './InstalledDialog'
import FailedDialog from './FailedDialog'
import { AnalyticsUtils, TemplateUtils, Enum } from 'utils'

import './managePlus.scss'

const SEVERITY_ICONS = [
  <DoneIcon color="#49A74C" />,
  <WarningIcon color="#FFBD36" />,
  <DangerIcon color="#FF4141" />,
]

export default class ManagePlus extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
    muiTheme:    React.PropTypes.object.isRequired,
    router:      React.PropTypes.object.isRequired
  }

  static propTypes = {
    checks:       React.PropTypes.object.isRequired,
    settings:     React.PropTypes.object,
    status:       React.PropTypes.object.isRequired,
    installed:    React.PropTypes.bool.isRequired,
    isInstalling: React.PropTypes.bool.isRequired,
    isUpgrade:    React.PropTypes.bool.isRequired,
    failed:       React.PropTypes.bool.isRequired,
    installNow:   React.PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.state = {
      showFailedDialog: false,
      showInstalledDialog: false
    }
  }

  componentWillMount() {
    CheckActions.fetch(this.context.currentUser.activeCharge)
  }

  upgrade() {
    PlusActions.install(this.context.currentUser, true)
  }

  handleRequestInstall() {
    PlusActions.requestPlusInstall(this.context.currentUser)
  }

  handleSelfInstall() {
    PlusActions.selfInstall()
  }

  handleRequestFreeInstallation() {
    PlusActions.requestFreeInstallation()
  }

  handleCreatePremiumSupportRequest() {
    PlusActions.createPremiumSupportRequest()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.failed) {
      this.setState({ showFailedDialog: true })
      return
    }

    if (!this.props.installed && nextProps.installed && !nextProps.isUpgrade) {
      this.setState({ showInstalledDialog: true })
    }
  }

  maybeShowFailedDialog() {
    return this.state.showFailedDialog && <FailedDialog />
  }

  maybeShowInstalledDialog() {
    return this.state.showInstalledDialog &&
      <InstalledDialog installed={this.props.installed}
        upgrade={this.props.isUpgrade}
        hasInclude={this.props.status.hasInclude}
        handleRequestInstall={::this.handleRequestInstall}
        handleSelfInstall={::this.handleSelfInstall} />
  }

  downgrade() {
    // BUG: the success or failure of .downgrade isn't handled and the router is called regardless, should handle errors and display confirmation on success
    // BUG: no confirmation dialog shown https://trello.com/c/pKCuvmbM/602-uninstall-downgrade
    PlusActions.downgrade(this.context.currentUser)
    this.context.router.replace('/')
  }

  renderInstall() {
    // Fetching plus installation status
    if (this.props.status.installed === undefined) return null
    if (this.props.isInstalling)
      return (
        <div className="flex-center--horizontal">
          <Button
            label='Installing...'
            buttonType="primary"
            disabled={true}
            className='manageplus__row__btn'
          />
          <h4 className="small-spacing2--top">Please wait: Currently installing Plug in SEO Plus in your shop...</h4>
        </div>
      )

    if (this.props.status.installed === true && this.props.status.hasInclude === false)
      return (
        <div className="installed-notice">
          <Notice alert header="Plug in SEO is partially installed">
            <p>Plug in SEO requires one more piece of code to be added manaully to your theme.</p>
            <p className="small-spacing--top">Already requested an install? One of our team members will be in touch within 1 business day to help you get set up.</p>
            <p className="small-spacing--top">Want to install yourself? Follow these instructions: <a href="https://support.pluginuseful.com/hc/en-us/articles/23534794660244-How-do-I-install-Plug-in-SEO-Plus-in-my-theme" target="_blank">How to Install Plug in SEO Plus In Your Theme</a>.</p>
            <p className="small-spacing--top">If you need any help email us at <HelpEmail />.</p>
          </Notice>
        </div>
      )

    if (this.props.status.installed === false) {
      return (
        <div className="flex-center--horizontal">
          <InstallButton
            label='Install'
            buttonType="cta"
            status={this.props.status}
            className='manageplus__row__btn'
            installNow={this.props.installNow}
            currentUser={this.context.currentUser}
          />
          <h4 className="small-spacing2--top">Install Plug in SEO Plus in your shop</h4>
        </div>
      )
    } else if (this.props.status.needsUpgrade) {
      return (
        <div className="flex-center--horizontal">
          <Button
            label='Upgrade'
            buttonType="primary"
            onTouchTap={::this.upgrade}
            className='manageplus__row__btn'
          />
          <h4 className="small-spacing2--top">There&apos;s a new version of Plug in SEO Plus available</h4>
        </div>
      )
    }
    
    // Installed and no further action needed
    return null
  }

  checkLink(checkName) {
    const check = this.props.checks.find(check => check.get('name') === checkName)

    if (check.get('enabled'))
      return `/checks/${check.get('key')}`
    else
      return `/checks/setup/${check.get('key')}`
  }

  handleClickEditSearchConsoleSettings() {
    AnalyticsUtils.clickedSearchConsoleSettings(this.context.currentUser.email)
    this.context.router.push('/plus/manage/search-console')
  }

  handleClickStructuredData(variantName) {
    this.context.router.push('/plus/manage/structured-data')
  }

  renderTemplatePageItem(title, resourceName, pathName) {
    const { settings } = this.props

    if (!settings) {
      return (
        <ListItem
          primaryText={<h4>{title}</h4>}
          rightIcon={<Arrow />}
          onTouchTap={ () => this.context.router.push(`/plus/manage/${pathName}`) }
          innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
        />
      )
    }

    let criticality
    const titleTemplateStr = settings[`pageTitle${resourceName}Template`]
    const descriptionTemplateStr = settings[`metaDescription${resourceName}Template`]

    if (resourceName === 'Index') {
      criticality = titleTemplateStr && descriptionTemplateStr ? 0 : 2
    } else {
      const titleCriticality = TemplateUtils.getCriticality(titleTemplateStr,
                                                            Enum.TitleTemplateFormula[resourceName],
                                                            Enum.TitleTemplateChecklist[resourceName])
      const descriptionCriticality = TemplateUtils.getCriticality(descriptionTemplateStr,
                                                                  Enum.DescriptionTemplateFormula[resourceName],
                                                                  Enum.DescriptionTemplateChecklist[resourceName])
      criticality = Math.max(titleCriticality, descriptionCriticality)
    }

    return (
      <ListItem
        primaryText={<h4>{title}</h4>}
        rightIcon={<Arrow />}
        leftIcon={SEVERITY_ICONS[criticality]}
        onTouchTap={ () => this.context.router.push(`/plus/manage/${pathName}`) }
        innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
      />
    )
  }

  render() {
    let palette = this.context.muiTheme.palette

    return (
      <div>
        <Helmet title='Plug in SEO Plus' />
        <Nav toolbarTitleText='Your Plug in SEO Plus Benefits' />
        <div className='manageplus'>
          <div className='manageplus__row'>
            {this.renderInstall()}
          </div>
          <div className='manageplus__row'>
            <div className='manageplus__column'>
              <div className='manageplus__panel'>
                <List>
                  <h2 className="manageplus__header">Title and Description Templates</h2>
                  <p className="manageplus__note">Create good SEO titles and descriptions that look great</p>
                </List>
                <List>
                  {this.renderTemplatePageItem('Products', 'Product', 'product')}
                  {this.renderTemplatePageItem('Collections', 'Collection', 'collection')}
                  {this.renderTemplatePageItem('Articles', 'Article', 'article')}
                  {this.renderTemplatePageItem('Blogs', 'Blog', 'blog')}
                  {this.renderTemplatePageItem('Pages', 'Page', 'page')}
                </List>
                <List>
                  <p className="manageplus__subhead">Special pages</p>
                  {this.renderTemplatePageItem('Homepage', 'Index', 'index')}
                  {this.renderTemplatePageItem('Catalog Page', 'Catalog', 'catalog')}
                  {this.renderTemplatePageItem('Search', 'Search', 'search')}
                  {this.renderTemplatePageItem('404', '404', '404')}
                </List>
                <List>
                  <p className="manageplus__subhead">Shopwide</p>
                  {this.renderTemplatePageItem('Default', 'Default', 'default')}
                </List>
              </div>

              <Card className='manageplus__card'>
                <CardHeader
                  avatar={<Avatar backgroundColor={palette.green} icon={<FontIcon className="material-icons">live_help</FontIcon>}/>}
                  title={<h2>Premium Support</h2>}
                  subtitle={<p className="manageplus__note manageplus__note--no-indent">Receive a detailed response to any SEO questions you have"</p>}
                />
                <CardText>
                  <p className="body1">Ask us anything about SEO. Detailed, personal responses to any of your SEO questions for no extra charge.</p>
                  <p className="body1 medium-spacing2--top">Simply email help+plus@pluginuseful.com and we&apos;ll help out.</p>
                </CardText>
                <CardActions>
                  <Button
                    label="Create Premium Support request"
                    buttonType="secondary"
                    href="mailto:help+plus@pluginuseful.com"
                    onTouchTap={::this.handleCreatePremiumSupportRequest}
                  />
                </CardActions>
              </Card>
            </div>

            <div className='manageplus__column'>
              <div className='manageplus__panel'>
                <List>
                  <h2 className="manageplus__header">Plus Checks</h2>
                  <p className="manageplus__note">Exclusive to Plug in SEO Plus</p>
                </List>
                <List>
                  <ListItem
                    primaryText={<h4>Broken links</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => this.context.router.push('/checks/notfound') }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                </List>
              </div>

              <div className='manageplus__panel'>
                <List>
                  <h2 className="manageplus__header">Settings</h2>
                  <p className="manageplus__note">Other settings to refine your SEO</p>
                </List>
                <List>
                  <ListItem
                    primaryText={<h4>Appender</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => this.context.router.push('/plus/manage/appender') }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                  <ListItem
                    primaryText={<h4>JSON LD Structured Data</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => this.handleClickStructuredData('B') }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                  <ListItem
                    primaryText={<h4>Advanced</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => this.context.router.push('/plus/manage/advanced') }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                  {this.props.legacyConsoleUser && (
                    <ListItem
                      primaryText={<h4>Google Search Console</h4>}
                      rightIcon={<Arrow />}
                      onTouchTap={ () => this.context.router.push('/plus/manage/search-console') }
                      innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                    />
                  )}
                </List>
              </div>

              <div className='manageplus__panel'>
                <List>
                  <h2 className="manageplus__header">Documentation & Help</h2>
                  <p className="manageplus__note">Browse documentation or send us a mail for priority support</p>
                </List>
                <List>
                  <ListItem
                    primaryText={<h4>Documentation</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => window.open('https://support.pluginuseful.com/') }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                  <ListItem
                    primaryText={<h4>Email help+plus@pluginuseful.com</h4>}
                    rightIcon={<Arrow />}
                    onTouchTap={ () => document.location = 'mailto:help+plus@pluginuseful.com' }
                    innerDivStyle={{paddingTop: 12, paddingBottom: 12}}
                  />
                </List>
              </div>

              <Card className='manageplus__card'>
                <CardHeader
                  avatar={<Avatar backgroundColor={palette.green} icon={<FontIcon className="material-icons">build</FontIcon>}/>}
                  title={<h2>Free installation</h2>}
                  subtitle={<p className="manageplus__note manageplus__note--no-indent">We&apos;ll do it for you, no extra charge</p>}
                />
                <CardText>
                  <p className="body1">Don&apos;t want to touch any code, or just want to make sure you&apos;ve installed Plug in SEO Plus in your theme correctly?</p>
                  <p className="body1 medium-spacing2--top">We&apos;ll do it for you for no extra charge.</p>
                </CardText>
                <CardActions>
                  <Button
                    label="Request free installation"
                    buttonType="secondary"
                    href="mailto:help+plus@pluginuseful.com?subject=Plus install"
                    onTouchTap={::this.handleRequestFreeInstallation}
                  />
                </CardActions>
              </Card>
            </div>
          </div>
        </div>

        { this.maybeShowInstalledDialog() }
        { this.maybeShowFailedDialog() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/ManagePlus.js